module.exports = __webpack_public_path__ + "img/logo-8320f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 142
// module chunks = 0 1